import { render } from "./PathwaysColumnMapping.vue?vue&type=template&id=6d2fb9f4"
import script from "./PathwaysColumnMapping.vue?vue&type=script&lang=js"
export * from "./PathwaysColumnMapping.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/pathways/PathwaysColumnMapping.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d2fb9f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d2fb9f4', __exports__)) {
    api.reload('6d2fb9f4', __exports__)
  }
  
  module.hot.accept("./PathwaysColumnMapping.vue?vue&type=template&id=6d2fb9f4", () => {
    api.rerender('6d2fb9f4', render)
  })

}


export default __exports__